// 分享相关的共用方法
import QRCode from 'qrcodejs2';
import '@/assets/js/html2canvas';

// 生成二维码
export const generateQRCode = (dom, config) => {
  const { logo, ...qrcodeConfig } = config || {};
  dom.innerHTML = '';
  const name = dom.id || 'qrcode';
  /* eslint-disable */
  new QRCode(name, {
    width: dom.clientWidth,
    height: dom.clientHeight,
    correctLevel: QRCode.CorrectLevel.H,
    ...qrcodeConfig
  });

  if (!logo || !logo.src) return;

  const logoNode = document.createElement('div');
  const size = logo.size || 84;
  const padding = logo.padding || 8;
  const radius = logo.radius || 12;
  const bgColor = logo.bgColor || '#f5ead8';

  logoNode.style.position = 'absolute';
  logoNode.style.top = '50%';
  logoNode.style.left = '50%';
  logoNode.style.width = `${size}px`;
  logoNode.style.height = `${size}px`;
  logoNode.style.transform = 'translate(-50%, -50%)';
  logoNode.style.zIndex = '3';
  logoNode.style.boxSizing = 'border-box';
  logoNode.style.border = `${padding}px solid ${bgColor}`;
  logoNode.style.borderRadius = `${radius}px`;
  logoNode.style.background = `${bgColor} url(${logo.src}) center center / cover no-repeat`;
  logoNode.style.boxShadow = '0 4px 12px rgba(121, 114, 114, 0.2)';

  dom.style.position = 'relative';
  dom.appendChild(logoNode);
};

// 生成图片
export const generateCanvasImage = (shareContent, options = {}) => {
  const width = shareContent.offsetWidth; // 获取dom 宽度
  const height = shareContent.offsetHeight; // 获取dom 高度
  const canvas = document.createElement('canvas'); // 创建一个canvas节点
  const scale = 1; // 定义任意放大倍数 支持小数
  canvas.width = width * scale; // 定义canvas 宽度 * 缩放
  canvas.height = height * scale; // 定义canvas高度 *缩放
  canvas.getContext('2d').scale(scale, scale); // 获取context,设置scale
  const opts = {
    scale: scale, // 添加的scale 参数
    canvas: canvas, // 自定义 canvas
    logging: true, //日志开关，便于查看html2canvas的内部执行流程
    width: width, // dom 原始宽度
    height: height,
    backgroundColor: null,
    useCORS: true, // 【重要】开启跨域配置
    ...options
  };
  const h2c = html2canvas || window.html2canvas;
  return h2c(shareContent, opts);
};



// WEBPACK FOOTER //
// ./src/utils/share.js